<template>
  <div class="protocol-wrap">
    <div class="__layout-wrap">
      <no-ssr>
        <AboutCompany
          v-if="type === 'about'"
          :act="act"
          @toggleTab="toggleTab"
        />
        <Login
          v-show="type === 'login'"
          :act="act"
          @toggleTab="toggleTab"
        />
        <commonProblem
          v-if="type === 'problem'"
          :act="act"
          @toggleTab="toggleTab"
        />
        <Vip
          v-if="type === 'pay'"
          :act="act"
          @toggleTab="toggleTab"
        />
      </no-ssr>
    </div>
  </div>
</template>

<script>
import {
  AboutCompany,
  Login,
  commonProblem,
  Vip
} from './components/index.js'
import merge from "webpack-merge";

export default {
  layout: "header-nav",

  components: {
    AboutCompany,
    Login,
    commonProblem,
    Vip
  },
  head() {
    return {
      title: this.titles[this.type][this.act]
    }
  },

  data() {
    return {
      headline: "",
      type: this.$route.params.type || this.$route.query.type || 'about',
      act: this.$route.params.act || this.$route.query.act || 0,
      titles: {
        'about': [
          '关于我们_潮国创意',
          '版权声明_潮国创意',
          '联系我们_潮国创意'
        ],
        'problem': [
          '用户协议_潮国创意',
          '版权声明_潮国创意',
          '隐私政策_潮国创意'
        ],
        'login': [
          '登录注册相关问题_潮国创意',
          '支付相关问题_潮国创意'
        ],
        'pay': [
          'VIP服务协议_潮国创意',
        ]
      }
    }
  },
  mounted() {
    // this.headline = this.tab[this.act];
  },
  methods: {
    toggleTab(act) {
      this.act = act;
      this.$router.push({
        query: merge(this.$route.query, {act, type: this.type})
      })
    }
  }
}
</script>

<style lang="scss" scoped>
._height-72 {
  height: 72px;
}

.__layout-wrap {
  width: 1202px;
  margin: 48px auto 80px;
}


</style>
